<template>
  <g-page-wrapper>
    <template slot="pageTitle">
      <g-page-title title="청구서"></g-page-title>
    </template>
    <g-contents class="-p-5">
    </g-contents>
  </g-page-wrapper>
</template>

<script>
import BillDetailPopup2 from './components/BillDetailPopup2'

export default {
  name: 'bill-detail',
  componentName: 'BillDetail',
  beforeMount() {
    this.$nextTick(() => {
      this.$popupManager.open(BillDetailPopup2)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/bill/BillDetail.vue